import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import './stylesheets/THead.scss';

class THead extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderColumn = this.renderColumn.bind(this);
    this.onColumnSort = this.onColumnSort.bind(this);
  }

  onColumnSort(column, direction, type) {
    const { thOnClick } = this.props;
    return () => thOnClick(column, direction, type);
  }

  renderColumn(column, index) {
    const { sort } = this.props;
    let thProps = {};

    if (column.sortable) {
      const sortKey = column.sortKey || column.key;
      if (sort && sort.column === sortKey) {
        const newDirection = sort.direction === 'asc' ? 'desc' : 'asc';
        thProps = {
          className: `sortable active ${sort.direction}`,
          onClick: this.onColumnSort(sortKey, newDirection, column.type)
        };
      } else {
        thProps = {
          className: 'sortable asc',
          onClick: this.onColumnSort(sortKey, 'asc', column.type)
        };
      }
    }

    return <th key={index} {...thProps} >{ column.label }</th>;
  }

  render() {
    const { columns, type } = this.props;
    const classes = {
      loc: true,
      thead: true,
      'default-thead': type === 'default',
      'card-thead': type === 'card'
    };

    return (
      <thead className={classNames(classes)} >
        <tr>
          { columns.map(this.renderColumn) }
        </tr>
      </thead>
    );
  }
}

THead.propTypes = {
  columns: PropTypes.array, //eslint-disable-line
  sort: PropTypes.object, //eslint-disable-line
  thOnClick: PropTypes.func,
  type: PropTypes.string
};

THead.defaultProps = { type: 'default' };

export default THead;



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/THead.jsx